module.exports = __webpack_public_path__ + "static/media/ig24.e80616a4.jpg";